module.exports = __webpack_public_path__ + "img/c-product-1.jpg";